import { useState } from "react";
import styles from "./Learn.module.css";
import arrowUp from "../../assets/icons/arrow-bar-up.svg";

<span className={styles.icon}>
  <img src={arrowUp} alt="Arrow Up" width="24" height="24" />
</span>

const learningTracks = [
  {
    id: 1,
    title: "Trading Track",
    description:
    (
      <>
        Learn the fundamentals, technical analysis,<br />
        and trading psychology.
      </>
    ),
    image: "images/TradingTrack.jpeg",
    courses: [
      "Introduction to Cryptocurrency",
      "Setting up for success",
      "Mastering trading psychology",
      "Market analysis basics",
      "Introduction to Technical Analysis",
      "Advance Technical Analysis",
      "Risk management strategies",
      "Strategic trading & portfolio management",
      "Long-term strategy overview",
      "Portfolio adjustments for traders",
      "Understanding trading costs",
      "Engaging in the trading community",
      "Navigating news & updates",
      "Trading skills assessment",
    ],
  },
  {
    id: 2,
    title: "Investment Track",
    description: "Develop long-term investment strategies and risk management skills",
    image: "images/InvestmentTrack.png",
    courses: [   
        "Introduction to Cryptocurrency",
        "Secure setup for investments",
        "Developing investor mindset",
        "Market trends and long-term analysis",
        "Indicators for investment timing",
        "Timing and analysis for long-term investment",
        "Diversification & allocation",
        "Smart investment strategies",
        "Core investment strategies",
        " Passive portfolio development",
        " Investment costs & tax consideration",
        " Connecting with other investors",
        " Tracking trends & news",
        " Investment knowledge assessment"
        ], 
    },
    ];

export default function Learn() {
  const [hoveredTrack, setHoveredTrack] = useState(null);

  return (
    <div className={styles.learnContainer}>
      <div className={styles.content}>
        <h2 className={styles.learnHeading}>Mastering Crypto with confidence.</h2>
        <p className={styles.learnSubheading}>
          Crypto trading doesn’t have to be complicated. At Xenorize, we make learning accessible,
          engaging, and rewarding—whether you're a beginner taking your first step or a trader
          looking to sharpen your skills.
        </p>
        <h3 className={styles.learnHeading2}>Structured Learning Paths | Practical Insights</h3>

        <div className={styles.learningTracks}>
          {learningTracks.map((track) => (
            <div
              key={track.id}
              className={`${styles.trackCard} ${hoveredTrack === track.id ? styles.expanded : ""}`}
              onMouseEnter={() => setHoveredTrack(track.id)}
              onMouseLeave={() => setHoveredTrack(null)}
            >
              <img src={track.image} alt={track.title} className={styles.trackImage} />
              <div className={styles.trackOverlay}>
                <div className={styles.trackHeader}>
                <div className={styles.circle}>
                    <span className={styles.trackNumber}>{track.id}</span>
                  </div>
                  <p className={styles.trackDescription}>{track.description}</p>
                  <div className={styles.divider}></div>
                  <div className={styles.trackTitleContainer}>
                    <h3 className={styles.trackTitle}>{track.title}</h3>
                    <span className={styles.icon}>
                      <img src={arrowUp} alt="Arrow Up" width="24" height="24" />
                    </span>
                  </div>
                </div>
                {hoveredTrack === track.id && track.courses.length > 0 && (
                  <ul className={styles.courseList}>
                    {track.courses.map((course, index) => (
                      <li key={index} className={styles.courseItem}>Course {index + 1} - {course}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
